import { ActionList, ActionMenu, Box } from "@primer/react";
import { ChevronDownIcon } from "@primer/octicons-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { dmMailTrungTuyenApi } from "../../api/dmMailTrungTuyenApi";
import { useCommonContext } from "../../contexts/common";
import { dm_mail_trungtuyen } from "../../models/response/category/dm_mail_trungtuyen";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";

export type ComboboxMailTrungTuyenProps = {
  isReadonly?: boolean;
  value?: number;
  onValueChanged: (id: number, data?: dm_mail_trungtuyen) => void;
  className?: string;
  isShowClearButton?: boolean;
  preText?: string;
  stylingMode?: "outlined" | "filled" | "underlined";
};

const ComboboxMailTrungTuyen = (props: ComboboxMailTrungTuyenProps) => {
  const [mailTemplates, setMailTemplates] = useState<dm_mail_trungtuyen[]>([]);
  const { translate } = useCommonContext();
  const { dm_coso_id } = useCommonSelectedHook();

  const handleReloadAsync = useCallback(async () => {
    try {
      const response = await dmMailTrungTuyenApi.selectAll();
      if (response.is_success) {
        let filtered = response.data.filter(
          (item: dm_mail_trungtuyen) => item.is_active !== false
        );

        // Chỉ lọc theo dm_coso_id từ useCommonSelectedHook
        if (dm_coso_id) {
          filtered = filtered.filter(
            (item: dm_mail_trungtuyen) => item.dm_coso_id === String(dm_coso_id)
          );
        }

        setMailTemplates(filtered);
      }
    } catch (error) {
      console.error("Error loading mail trung tuyen templates:", error);
    }
  }, [dm_coso_id]);

  useEffect(() => {
    handleReloadAsync();
  }, [handleReloadAsync]);

  const { value, onValueChanged } = props;

  const selectedData = useMemo(() => {
    if (value && mailTemplates) {
      const found = mailTemplates.find((x) => x.id === value);
      return found;
    }
    return undefined;
  }, [mailTemplates, value]);

  return (
    <Box sx={{ width: "100%", maxWidth: "400px" }}>
      <ActionMenu>
        <ActionMenu.Button
          aria-label="Select mail trung tuyen template"
          className="button-left"
          sx={{
            width: "400px !important",
            maxWidth: "400px !important",
            overflow: "hidden !important",
            display: "flex !important",
            "& > span": {
              overflow: "hidden !important",
              textOverflow: "ellipsis !important",
              whiteSpace: "nowrap !important",
              display: "block !important",
              maxWidth: "360px !important",
            }
          }}
          trailingAction={ChevronDownIcon}
        >
          <span style={{ 
            display: "block",
            overflow: "hidden", 
            textOverflow: "ellipsis", 
            whiteSpace: "nowrap", 
            maxWidth: "360px",
            width: "100%"
          }}>
            {selectedData
              ? selectedData.email_subject
              : props.preText || translate("Chọn mẫu email trúng tuyển")}
          </span>
        </ActionMenu.Button>
        <ActionMenu.Overlay width="large">
          <ActionList selectionVariant="single">
            {props.isShowClearButton && (
              <ActionList.Item
                key={0}
                selected={value !== undefined && 0 === value}
                onSelect={() => {
                  onValueChanged(0);
                }}
              >
                Chọn mẫu email
              </ActionList.Item>
            )}
            {mailTemplates &&
              mailTemplates.map((item) => {
                return (
                  <ActionList.Item
                    key={item.id}
                    selected={value !== undefined && item.id === value}
                    onSelect={() => {
                      onValueChanged(item.id, item);
                    }}
                  >
                    {item.email_subject}
                  </ActionList.Item>
                );
              })}
            {mailTemplates.length === 0 && (
              <ActionList.Item disabled>
                Không có mẫu email nào
              </ActionList.Item>
            )}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </Box>
  );
};

export { ComboboxMailTrungTuyen };

